import { useFetchData } from "../../../hooks/useFetch";
import { ApiConfig, API_HRM_SETTINGS_ROUTER } from "../../../services/api-config";

/** Tọa độ + bán kính trụ sở chính — nơi hrm fallback về khi 1 chi nhánh chưa cấu hình tọa độ riêng
 * (xem BranchLocationService bên hrm, và form chi nhánh: features/branch/components/branch-create-modal.tsx). */
export interface CompanyLocation {
  latitude: number;
  longitude: number;
  radius: number;
  address?: string;
}

/**
 * Toàn bộ "Cài đặt chung" của hrm (`SETTING_KEYS.COMPANY_SETTING`). BE nhận/trả NGUYÊN CỤM này —
 * không có endpoint patch riêng từng phần — nên FE phải GET trước, chỉ sửa phần cần đổi
 * (`company_location`), rồi POST lại nguyên object để không làm mất các phần khác (lịch làm việc,
 * chính sách đi trễ/về sớm, nghỉ trưa...) mà trang này chưa có UI để hiển thị/sửa.
 */
export interface CompanySetting {
  company_location: CompanyLocation;
  working_schedules: Array<{ weekday: number; start_time: string; end_time: string; is_active: number }>;
  max_salary_advance_percent: number;
  annual_leave_entitlement: number;
  lunch_break: { start: string; end: string };
  timekeeping_policy_config: {
    minutes_for_half_workday: number;
    minutes_for_no_workday: number;
    attendance_penalty_amount: string;
  };
  contract_expiration_reminder_days: number;
}

const HrmSettingService = {
  getCompanySetting: () => {
    const { request, baseResponse, loading } = useFetchData.Get<CompanySetting>({
      projectId: ApiConfig.PROJECT_ID.HRM_SERVICE,
    });
    return {
      fetch: () => request({ endPoint: API_HRM_SETTINGS_ROUTER.API_COMPANY_SETTING }),
      response: baseResponse,
      loading,
    };
  },
  updateCompanySetting: () => {
    const { request, baseResponse, loading } = useFetchData.Post<null>({
      projectId: ApiConfig.PROJECT_ID.HRM_SERVICE,
    });
    return {
      // Luôn gửi NGUYÊN object CompanySetting (xem ghi chú ở interface) — không phải patch từng field.
      fetch: (payload: CompanySetting) => request({ endPoint: API_HRM_SETTINGS_ROUTER.API_COMPANY_SETTING, data: payload }),
      response: baseResponse,
      loading,
    };
  },
};

export default HrmSettingService;
